{
  "login": "登入",
  "logout": "登出",
  "signOut": "登出",
  "username": "用戶名稱",
  "password": "密碼",
  "forgotPassword": "忘記密碼？",
  "rememberMe": "記住我",
  "loginButton": "登入",
  "loginError": "用戶名稱或密碼錯誤",
  "sessionExpired": "您的工作階段已過期，請重新登入。",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "正在登入...",
  "loginSuccess": "登入成功",
  "showPassword": "顯示密碼",
  "hidePassword": "隱藏密碼",
  "onboardingPrompt": "為您的醫院或診所?",
  "onboardingCta": "申請導入",
  "loginFailed": "登入失敗",
  "seatCapReached": "已達到此授權的用戶上限。請聯絡管理員。",
  "mfaCodeLabel": "驗證碼",
  "mfaCodePrompt": "請輸入驗證器應用程式中的6位數驗證碼以完成登入。",
  "mfaSetupRequired": "您的機構要求啟用多重身份驗證。請設定您的驗證器應用程式後繼續。",
  "mfaCodePlaceholder": "6位數驗證碼",
  "mfaInvalidCode": "驗證碼無效",
  "pages": {
    "userProfile": {
      "title": "我的帳戶",
      "loading": "正在載入帳戶資料...",
      "sections": {
        "profilePicture": "頭像",
        "personalInformation": "個人資料",
        "changePassword": "更改密碼",
        "multiFactorAuth": "多重身份驗證"
      },
      "fields": {
        "fullName": "姓名",
        "email": "電郵",
        "phone": "電話",
        "currentPassword": "目前密碼",
        "newPassword": "新密碼",
        "confirmPassword": "確認新密碼",
        "required": "*"
      },
      "actions": {
        "saveChanges": "儲存變更",
        "changePassword": "更改密碼",
        "setUpMfa": "設定多重身份驗證",
        "uploadAvatar": "上傳",
        "changeAvatar": "更換",
        "removeAvatar": "移除",
        "verify": "驗證"
      },
      "avatar": {
        "alt": "頭像",
        "helperText": "支援 PNG、JPEG 或 WebP 格式，最大 4 MB。上傳前將調整為 {{size}}×{{size}}。"
      },
      "mfa": {
        "enabledMessage": "您的帳戶已啟用多重身份驗證。",
        "intro": "啟用多重身份驗證，為您的帳戶增添額外的安全保障。",
        "scanInstruction": "請使用您的驗證器應用程式掃描此 URI，或手動複製：",
        "copyUri": "複製 URI",
        "verificationCode": "驗證碼",
        "codePlaceholder": "請輸入 6 位數驗證碼"
      },
      "validation": {
        "fullNameRequired": "請輸入姓名",
        "emailRequired": "請輸入有效的電郵",
        "currentPasswordRequired": "請輸入目前密碼",
        "newPasswordTooShort": "密碼至少需要 8 個字元",
        "confirmPasswordRequired": "請確認密碼",
        "passwordsMismatch": "兩次輸入的密碼不一致"
      },
      "toasts": {
        "profileUpdated": "帳戶資料已更新",
        "profileUpdateFailed": "帳戶資料更新失敗",
        "passwordChanged": "密碼已更改",
        "passwordChangeFailed": "更改密碼失敗，請確認目前密碼是否正確。",
        "mfaSetupFailed": "無法啟動多重身份驗證設定",
        "mfaEnabled": "已啟用多重身份驗證",
        "mfaInvalidCode": "驗證碼無效",
        "avatarUpdated": "頭像已更新",
        "avatarUpdateFailed": "頭像更新失敗",
        "avatarRemoved": "頭像已移除",
        "avatarRemoveFailed": "頭像移除失敗",
        "imageTooLarge": "圖片大小不能超過 4 MB",
        "imageTooLargeServer": "圖片太大，請改用較細的檔案",
        "copiedToClipboard": "已複製到剪貼簿"
      }
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "您嘅工作階段將喺 1 分鐘內過期，請即刻儲存您嘅工作。",
      "expiringSoon_one": "您嘅工作階段將喺 {{count}} 分鐘後過期。",
      "expiringSoon_other": "您嘅工作階段將喺 {{count}} 分鐘後過期。",
      "extendButton": "延長工作階段"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "初始設定",
    "subtitle": "為此安裝建立第一個管理員帳戶。",
    "username": "用戶名稱",
    "password": "密碼",
    "confirmPassword": "確認密碼",
    "fullName": "全名（選填）",
    "fullNamePlaceholder": "例如：陳大文",
    "email": "電郵（選填）",
    "submit": "建立管理員帳戶",
    "submitting": "正在建立帳戶…",
    "usernameHint": "3–64 個字元：小寫字母、數字、點、底線及連字號。",
    "passwordHint": "最少 12 個字元，須包含大寫字母、小寫字母、數字及特殊字元。",
    "errUsername": "請使用 3–64 個字元：a–z、0–9、點、底線或連字號。",
    "errPasswordLength": "密碼長度最少為 12 個字元。",
    "errPasswordUpper": "密碼須包含大寫字母。",
    "errPasswordLower": "密碼須包含小寫字母。",
    "errPasswordDigit": "密碼須包含數字。",
    "errPasswordSpecial": "密碼須包含特殊字元。",
    "errConfirmRequired": "請確認密碼。",
    "errConfirmMismatch": "兩次輸入的密碼不一致。",
    "errFullName": "全名不可超過 100 個字元。",
    "errEmail": "請輸入有效的電郵地址。",
    "successTitle": "管理員帳戶已建立",
    "successBody": "帳戶「{{username}}」已可使用。請登入以繼續。",
    "goToLogin": "前往登入",
    "claimedTitle": "設定已完成",
    "claimedBody": "此系統已有管理員。請使用您的帳戶登入。",
    "networkError": "無法連接伺服器。請檢查網絡連線後再試一次。",
    "retry": "重試",
    "rateLimited": "嘗試次數過多。請稍候一分鐘再試。",
    "usernameTaken": "此用戶名稱已被使用。",
    "submitFailed": "無法建立帳戶。請再試一次。"
  }
}
